module.exports = __webpack_public_path__ + "static/media/staff.fca8d358.svg";